/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const clearUrlAndReplace = () => {
  let url = new URL(window.location.href);

  let email = url.searchParams.get('email');
  let token = url.searchParams.get('key');

  if (email && token) {
    url.searchParams.delete('email');
    url.searchParams.delete('key');

    window.history.replaceState({}, document.title, url.toString());
  }
};
